import type { RouteRecordRaw } from 'vue-router'
import { prefixRoutes, route } from '@/router/utils'
import type { Options } from '@/router'
import { i18n } from '@/i18n'
import { accessPermission } from '@m/user/permissions'

const PROFILE_PREFIX = 'cabinet:orders'
const p = (name: string) => PROFILE_PREFIX + ':' + name

export const ORDER_CATALOG_VIEW_NAME = p('catalog-view')
export const ORDER_DETAILS_VIEW_NAME = p('details-view')

const OrderCatalogView = () => import('./views/CatalogOfOrders.vue')
const OrderDetailsView = () => import('./views/DetailsOfOrder.vue')

const BASE_MODEL_NAME = 'orders/'

export function createRoutes(options: Options): RouteRecordRaw[] {
  const { t: $t } = i18n.global

  return [
    route(
      'catalog/',
      OrderCatalogView,
      ORDER_CATALOG_VIEW_NAME, //cabinet/orders/catalog
      {
        meta: {
          title: () => $t('Замовлення'),
        },
    }),
    route(
      'details/:id/',
      OrderDetailsView,
      ORDER_DETAILS_VIEW_NAME, //cabinet/orders/details/{id}/
      {
        meta: {
          title: () => $t('Деталі замовлення'),
          fallbackRouteName: ORDER_CATALOG_VIEW_NAME,
        },
    }),
  ]
}

export { BASE_MODEL_NAME }